import { ApolloListQuery } from 'core/types/ApolloListQuery';
import { extractQueryListItems } from 'core/utils/apollo/extractListItems';
import { updateItemInListById } from 'core/utils/apollo/updateItemInListById';

type UpdateApolloListByIdProps<T> = {
  prevData: NonNullable<ApolloListQuery<T>>;
  updatedItem: Partial<T> & Record<string, unknown>;
  idKey: string;
};

export const updateApolloListById = <T>({
  prevData,
  updatedItem,
  idKey
}: UpdateApolloListByIdProps<T>) => {
  const list = extractQueryListItems(prevData);
  if (!list) return prevData;
  const key = Object.keys(prevData)[0];
  return {
    ...prevData,
    [key]: {
      ...prevData[key],
      items: updateItemInListById({
        list,
        updatedItem,
        idKey
      })
    }
  };
};
